/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseDateFieldLook } from './DatabaseDateFieldLook';
import {
    DatabaseDateFieldLookFromJSON,
    DatabaseDateFieldLookFromJSONTyped,
    DatabaseDateFieldLookToJSON,
} from './DatabaseDateFieldLook';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

/**
 * 
 * @export
 * @interface DatabaseCreatedDateField
 */
export interface DatabaseCreatedDateField extends DatabaseField {
    /**
     * 
     * @type {DatabaseDateFieldLook}
     * @memberof DatabaseCreatedDateField
     */
    appearance?: DatabaseDateFieldLook;
}

/**
 * Check if a given object implements the DatabaseCreatedDateField interface.
 */
export function instanceOfDatabaseCreatedDateField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseCreatedDateFieldFromJSON(json: any): DatabaseCreatedDateField {
    return DatabaseCreatedDateFieldFromJSONTyped(json, false);
}

export function DatabaseCreatedDateFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseCreatedDateField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'appearance': !exists(json, 'appearance') ? undefined : DatabaseDateFieldLookFromJSON(json['appearance']),
    };
}

export function DatabaseCreatedDateFieldToJSON(value?: DatabaseCreatedDateField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'appearance': DatabaseDateFieldLookToJSON(value.appearance),
    };
}

